import ImageIcon from "@mui/icons-material/Image";
import { Box, Card, Stack, Typography } from "@mui/material";
import { graphql } from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";
import { InternBrandStyleFavicon_brand$key } from "./__generated__/InternBrandStyleFavicon_brand.graphql";

const brandFragment = graphql`
  fragment InternBrandStyleFavicon_brand on BrandType {
    id
    internStyle {
      favicon
    }
  }
`;

type InternBrandStyleFaviconProps = {
  brand: InternBrandStyleFavicon_brand$key;
};

const InternBrandStyleFavicon = ({
  brand: brandKey,
}: InternBrandStyleFaviconProps) => {
  const brand = useFragment(brandFragment, brandKey);

  const favicon = brand.internStyle?.favicon;
  const hasFavicon = !!favicon;

  return (
    <Card
      sx={{
        p: 2,
        width: "100%",
        minWidth: 0,
        flex: 1,
      }}
    >
      <Typography variant="h6" mb={2} fontWeight={600}>
        Favicon
      </Typography>

      <Stack direction="row" spacing={4} sx={{ width: "100%" }}>
        {hasFavicon ? (
          <Box
            sx={{
              width: "64px",
              height: "64px",
              borderRadius: "8px",
              overflow: "hidden",
              border: "1px solid #DBDCDD",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#FFFFFF",
            }}
          >
            <img
              src={favicon}
              alt="Brand favicon"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
              onError={(e) => {
                // Fallback to zero state if image fails to load
                const target = e.target as HTMLImageElement;
                target.style.display = "none";
                target.nextElementSibling?.setAttribute(
                  "style",
                  "display: flex"
                );
              }}
            />
          </Box>
        ) : (
          <Box
            sx={{
              width: "64px",
              height: "64px",
              borderRadius: "8px",
              border: "2px dashed #DBDCDD",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#F5F5F5",
            }}
          >
            <ImageIcon sx={{ fontSize: 32, color: "#999" }} />
          </Box>
        )}
      </Stack>
    </Card>
  );
};

export default InternBrandStyleFavicon;
